<template>
    <div :id="ids.type" class="btn configuration flex-y-center" @click="Select($event)" @keypress.space.prevent="Select($event)" @mouseenter="Hover(true)" @mouseleave="Hover()" tabindex="0" v-if="configuration.show && showOptions">
        <Details
            :iconSource="iconSource"
            :name="configuration.name"
            :index="index"
            :expanded="expanded"
        />
    </div>
</template>

<script>
import Details from "@/components/Timeline/YBar/Configuration/Details.vue";
import $ from "jquery";

export default {
    name: "TimelineConfiguration",
    props: {
        configuration: Object,
        expanded: Boolean,
        showOptions: Boolean,
        index: Number,
        showZoomControl: Boolean
    },
    components: { Details },
    data: () => ({
        ids: { type: "" },
        iconSource: ""
    }),
    methods: {
        IconSource: function(over) {
            const { icons, main, name } = this.configuration;
            let source = over ? icons.active : icons.inactive;

            // Check for active states
            const controlMain = main && this.expanded;
            const controlZoom = name === "Zoom" && this.showZoomControl;
            if (controlMain || controlZoom) {
                source = icons.active;
            }

            return require(`@/assets/Images/TimelineConfigurations/${source}`);
        },
        Hover: function(over) {
            this.iconSource = this.IconSource(over);
        },
        Select: function(target) {
            this.$emit("select", this.configuration);
            $(target.target).focus();
        }
    },
    beforeMount: function() {
        this.ids.type = this.configuration.main ? "main" : "";
        this.iconSource = this.IconSource(false);
    },
    emits: [ "select" ]
};
</script>